var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 197,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-380 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383 71.3814C383 75.7204 383.543 79.9147 384.483 83.9644 392.17 131.747 445.325 182.151 483.414 196 513.528 185.062 552.973 151.236 572 113.939 534.218 69.8267 484.843 35.9466 428.595 16.9998 402.696 21.6461 383 44.1545 383 71.3814Z",
    fill: "#FFAC33",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 59.0701C607 28.6495 582.165 4.00013 551.555 4.00013 532.965 4.00013 516.565 13.1155 506.5 27.0493 496.436 13.1155 480.035 4.00013 461.445 4.00013 430.817 4.00013 406 28.6495 406 59.0701 406 63.385 406.543 67.5562 407.484 71.5835 415.196 119.102 468.378 169.228 506.5 183 544.622 169.228 597.804 119.102 605.498 71.6015 606.457 67.5562 607 63.385 607 59.0701Z",
    fill: "#DD2E44",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory41);
export default __webpack_public_path__ + "static/media/accessory4-1.129b3cd9bf1f7c2a0e5f0cde35fc2491.svg";
export { ForwardRef as ReactComponent };